import ModelUtil from '@leverege/model-util';
import { DateTimeRangePicker } from '@leverege/ui-elements';

/**
 * This is very similar to the Molten Table Filter Model
 * but I'm not sure how I could use that directly without causing
 * a dependency cycle, so I made a specific one here.
 */

const TYPE = 'rsrc.Table.FilterModel';
const ALLOWED_SORTS = ['id', 'projectId', 'ownerId', 'coownerId', 'path', 'type', 'createdAt', 'updatedAt'];
function create(extend) {
  return {
    type: TYPE,
    filters: {
      createdAt: 'last24Hours'
    },
    sorts: [{
      field: 'createdAt',
      order: 'DESC'
    }],
    ...extend
  };
}
const filtersAccess = {
  ...ModelUtil.createAllMap('filters', 'Filter', 'Filters'),
  ...ModelUtil.createAllArray('sorts', 'Sort', 'Sorts')
};
function toRsrcFilter(model) {
  // Rsrc's have no real filtering right now
  const filters = filtersAccess.getFilters(model);
  const path = getPath(model);
  const toReturn = {
    type: 'ExpressionField.logical',
    operator: 'and',
    conditions: [],
    path
  };
  if (filters?.expression) {
    toReturn.conditions.push({
      type: 'ExpressionField.expression',
      value: filters.expression
    });
  }
  if (filters?.createdAt) {
    const range = DateTimeRangePicker.getRange(filters.createdAt);
    if (range?.start && range.end) {
      toReturn.conditions.push({
        type: 'ExpressionField.comparator',
        left: {
          type: 'ExpressionField.basic',
          value: 'createdAt'
        },
        right: range.start instanceof Date ? range.start.toISOString() : range.start,
        comparator: '>='
      }, {
        type: 'ExpressionField.comparator',
        left: {
          type: 'ExpressionField.basic',
          value: 'createdAt'
        },
        right: range.end instanceof Date ? range.end.toISOString() : range.end,
        comparator: '<='
      });
    }
  }
  return toReturn.conditions.length > 0 ? toReturn : {
    path
  };
}
function toRsrcOrder(model) {
  const sorts = filtersAccess.getSorts(model);
  const order = [];
  sorts.forEach(s => {
    if (!ALLOWED_SORTS.includes(s.field)) {
      return;
    }
    order.push([s.field, s.order.toUpperCase()]);
  });
  return order.length > 0 ? order : null;
}
function getPath(model) {
  const filters = model ? filtersAccess.getFilters(model) : null;
  return filters?.path;
}
export default {
  TYPE,
  create,
  ...filtersAccess,
  toRsrcOrder,
  toRsrcFilter,
  getPath
};